module.exports = __webpack_public_path__ + "static/img/agree.bee65a7e.png";